export const componentLoader = (
  lazyComponent,
  attemptsLeft = 5,
  timeout = 500,
) => {
  return new Promise((resolve, reject) => {
    lazyComponent()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (attemptsLeft === 1) {
            reject(error);
            return;
          }
          componentLoader(lazyComponent, attemptsLeft - 1, timeout).then(
            resolve,
            reject,
          );
        }, timeout);
      });
  });
};
